var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "10.5 0.5 10.5 10.54 15.5 13.42 15.5 3.46 10.5 0.5",
    opacity: 0.33,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,0H10L0,2V13l5,3H6l10-2V3Zm4,12.62-4-2.19V5l4-.8Zm-.49-9.35L11,4V1.17ZM10,1V4.19L6,5,1.69,2.68Zm0,4.2V10l-4,.8V6ZM5,5.56V11l-4,.8V3.37ZM1.49,12.73,5,12v2.82ZM6,11.81,10,11l4.32,2.32L6,15Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/right.ff93fea5e54ca4b73f0b7404ac956733.svg";